import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { inp, btn, btn2, Pill } from "../../lib/ops";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { RequestDialog } from "./RequestDialog";

export const PlanStart = ({ meta, onClose }) => {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [ask, setAsk] = useState(null);
  const search = (term) => api.get(`/ops/eligible?q=${encodeURIComponent(term)}`).then((r) => setRows(r.data)).catch((x) => toast.error(errMsg(x)));
  useEffect(() => { search(""); }, []);
  const plan = (uid) => api.post("/ops/plans", { uid }).then((r) => {
    const t = r.data.template;
    toast.success(t ? `Plan made from the ${t.template} template: ${t.steps} steps, ${t.start} to ${t.end}` : `Plan started for ${uid}`);
    if (t?.warning) toast.warning(t.warning, { duration: 12000 });
    nav(`/ops/uid/${uid}`);
  }).catch((x) => toast.error(errMsg(x)));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-card max-h-[90vh] overflow-y-auto" data-testid="plan-start-dialog">
        <DialogHeader><DialogTitle>Start an operations plan</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Open POs and CS jobs can be planned straight away. A Pre-PO needs Production Head or founder approval first.</p>
        <form onSubmit={(e) => { e.preventDefault(); search(q); }} className="flex gap-2">
          <input data-testid="plan-start-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="UID, customer or description" className={inp} />
          <button data-testid="plan-start-search-button" className={btn2}>Search</button>
        </form>
        <div className="divide-y border" data-testid="plan-start-results">
          {rows === null && <div className="p-4 text-sm text-muted-foreground">Loading…</div>}
          {rows?.length === 0 && <div className="p-4 text-sm text-muted-foreground">No unplanned UIDs found.</div>}
          {rows?.map((o) => (
            <div key={o.uid} className="p-3 flex items-center gap-3" data-testid={`plan-start-row-${o.uid}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate"><span className="font-mono text-xs mr-2">{o.uid}</span>{o.client_name}</div>
                <div className="text-xs text-muted-foreground truncate">{o.record_class.replace("_", "-")} · {o.description || "—"}</div>
              </div>
              {o.needs_approval
                ? (o.approval_pending ? <Pill tone="bg-amber-100 text-amber-800" tid={`plan-start-pending-${o.uid}`}>Approval pending</Pill>
                  : <button data-testid={`plan-start-ask-${o.uid}`} onClick={() => setAsk(o.uid)} className={btn2}>Ask approval</button>)
                : <button data-testid={`plan-start-go-${o.uid}`} onClick={() => plan(o.uid)} className={btn}>Plan</button>}
            </div>))}
        </div>
        {ask && <RequestDialog kind="prepo_start" uid={ask} meta={meta} onClose={() => setAsk(null)} onDone={() => search(q)} />}
      </DialogContent>
    </Dialog>
  );
};
